import { Box, Divider, H4, Spinner } from '@ouster/webviz-react-components';

import { MdOutlineStorage } from 'react-icons/md';

import DashboardCard from './DashboardCard';
import InfoItem from './InfoItem';
import { InfoItemType } from './types';
import { formatDate } from './utils';
import { useStoreState } from '../../reducers';

export default function RecordingLookUpData() {
  const { recordingLookupResult, isLoadingRecordingLookup } = useStoreState(
    (storeState) => storeState.adminDashboard
  );

  const cardProps = {
    icon: <MdOutlineStorage size={20} />,
    title: 'Recording Data',
  };

  if (isLoadingRecordingLookup) {
    return (
      <DashboardCard {...cardProps}>
        <Box display="flex" alignItems="center" justifyContent="center" my={8}>
          <Spinner />
        </Box>
      </DashboardCard>
    );
  }

  if (!recordingLookupResult) return null;

  const osfItems: InfoItemType[] = [
    {
      label: 'Status',
      value: recordingLookupResult.osf_generation_status,
      color:
        recordingLookupResult.osf_generation_status === 'FINISHED'
          ? 'success'
          : 'warning',
    },
    {
      label: 'Generated',
      value: recordingLookupResult.osf_generation_date
        ? formatDate(recordingLookupResult.osf_generation_date.toString())
        : 'N/A',
    },
    {
      label: 'Bucket',
      value: recordingLookupResult.osf_prefix ?? '',
    },
  ];
  const slamItems: InfoItemType[] = [
    {
      label: 'Status',
      value: recordingLookupResult.slam_generation_status,
      color:
        recordingLookupResult.slam_generation_status === 'FINISHED'
          ? 'success'
          : 'warning',
    },
    {
      label: 'Generated',
      value: recordingLookupResult.slam_generation_date
        ? formatDate(recordingLookupResult.slam_generation_date.toString())
        : 'N/A',
    },
    {
      label: 'Bucket',
      value: recordingLookupResult.osf_prefix ?? '',
    },
  ];

  return (
    <DashboardCard
      {...cardProps}
      data-testid="recording-lookup-recording-data-card"
    >
      <Box display="grid" rowGap={6}>
        <H4
          color="blue.100"
          fontSize={15}
          data-testid="recording-lookup-original-title"
        >
          Original Data
        </H4>
        <InfoItem
          label="Source Bucket"
          value={recordingLookupResult.source_prefix ?? 'N/A'}
          data-testid="recording-lookup-source-bucket"
        />
        <Divider borderColor="gray.500" />
        <H4
          color="blue.100"
          fontSize={15}
          data-testid="recording-lookup-osf-title"
        >
          OSF Generation
        </H4>
        <Box
          display="grid"
          gridTemplateColumns="repeat(3, 1fr)"
          columnGap={4}
          rowGap={6}
          data-testid="recording-lookup-osf-section"
        >
          {osfItems.map((item) => (
            <InfoItem
              key={item.label}
              label={item.label}
              value={item.value}
              color={item.color}
              data-testid={`recording-lookup-osf-item-${item.label
                .toLowerCase()
                .replace(/\s/g, '-')}`}
            />
          ))}
        </Box>
        <Divider borderColor="gray.500" />
        <H4
          color="blue.100"
          fontSize={15}
          data-testid="recording-lookup-slam-title"
        >
          SLAM Generation
        </H4>
        <Box
          display="grid"
          gridTemplateColumns="repeat(3, 1fr)"
          columnGap={4}
          rowGap={6}
          data-testid="recording-lookup-slam-section"
        >
          {slamItems.map((item) => (
            <InfoItem
              key={item.label}
              label={item.label}
              value={item.value}
              color={item.color}
              data-testid={`recording-lookup-slam-item-${item.label
                .toLowerCase()
                .replace(/\s/g, '-')}`}
            />
          ))}
        </Box>
      </Box>
    </DashboardCard>
  );
}
